<div class="profilte-top-wrapper" fxLayout="row" fxLayoutAlign="space-between center" >
  <!-- <h1 class="top-title">Your Account</h1> -->
  <h1 mat-dialog-title class="top-title" (click)="betaSettings()" [attr.title]="!environment.production ? 'Click to navigate to Beta Settings' : 'Your account'" [ngClass]="{'clickable' : !environment.production}" >Your Account</h1>
  <span  *ngIf="isAccountRegionShown" class="delete-btn" (click)="deleteAccClick()">Delete</span>
</div>
<div class="profile-wrapper">

  <div class="region-head" fxLayout="row"(click)="toggleRegion($event, PROFILE_REGION.RENDER_LIMIT)" fxLayoutAlign="space-between stretch" >
    <h2 class="region-title" [ngClass]="{'active': isRenderLimitRegionShown}" (click)="toggleRegion($event, PROFILE_REGION.RENDER_LIMIT)">Billing</h2>
    <svg *ngIf="!isRenderLimitRegionShown" class="arrow-right"  width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="toggleRegion($event, PROFILE_REGION.RENDER_LIMIT)">
      <path d="M0.75 0.75L5.75 7L0.75 13.25" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)"/>
    </svg>
    <svg *ngIf="isRenderLimitRegionShown" class="arrow-down"  width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="toggleRegion($event, PROFILE_REGION.RENDER_LIMIT)" >
      <path d="M13.25 0.75L7 5.75L0.75 0.75" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)" />
    </svg>
  </div>

  <ng-container  #renderLimitRegion *ngIf="this.isRenderLimitRegionShown"  >
    <div class="profile-section" fxLayout="column" [@slideToggle]="isRenderLimitRegionShown">
      <!-- Show upload count only for TRIAL users -->
      <div class="top-level-zone" *ngIf="isTrial()" fxFlex="1 1 100" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="left-info">
          <h3>{{getUploadsLeft()}}</h3>
          <p>{{getUploadsLeft() === 1 ? 'upload' : 'uploads'}} left during free trial</p>
        </div>
        <div class="right-price">
          <!-- <h4>$4.99</h4><p class="small">per upload</p> -->
        </div>
      </div>
      <!-- Show trial expired message for TRIAL_EXPIRED users -->
      <!-- <div class="top-level-zone" *ngIf="isTrialExpired()" fxFlex="1 1 100" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="left-info">
          <p>Your free trial has expired</p>
        </div>
      </div> -->

      <button class="profile-btn disabledButClickable" (click)="onManageSubscriptionClicked()">
        <span>Manage Membership</span>
      </button>
      <p class="subscription-status-label" *ngIf="isSubscriber() && firebaseAuth.currentUser?.subscriptionEndDateTime && !firebaseAuth.currentUser?.isAutoRenewDisabled">
        Scheduled to Auto Renew starting on {{ getSubscriptionRenewalDate() }}<br>
        Active membership till {{ getFormattedEndDate() }}<br>
        <br>You can't manage membership in the app.<br> We know, it's not ideal.
      </p>
      <p class="subscription-status-label" *ngIf="firebaseAuth.currentUser?.subscriptionEndDateTime && firebaseAuth.currentUser?.isAutoRenewDisabled && !isExpired()">
        <span class="red-label">You are no longer enrolled in Membership Auto Renew.</span> <br>
        Active membership till {{ getFormattedEndDate() }}<br>
        <br>You can't renew membership in the app.<br> We know, it's not ideal.
      </p>
      <p class="subscription-status-label" *ngIf="isExpired()">
        <span class="red-label">You have cancelled your membership.</span> <br>
        Your membership ended on {{firebaseAuth.currentUser?.subscriptionEndDateTime | date:'MMM dd, yyyy'}}.<br><br>
        You can't renew membership in the app.<br> We know, it's not ideal.
      </p>
      <div class="profile-section-bottom-part" *ngIf="shouldShowRenderLimitSelector()" fxFlex="1 1 100" fxLayout="row" fxLayoutAlign="center center">
        <app-renderlimit-select [isRenderLimitTitleShown]="true" [inputMaxElementsInRow]="4" (renderLimitChange)="onRenderLimitChanged($event)"></app-renderlimit-select>
      </div>
    </div>
  </ng-container>

  <div class="profile-region" >
    <div class="region-head" fxLayout="row" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)" fxLayoutAlign="space-between stretch" >
      <h2 class="region-title" [ngClass]="{'active': isAccountRegionShown}" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)">Account Management</h2>
      <svg *ngIf="!isAccountRegionShown" class="arrow-right"  width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)">
        <path d="M0.75 0.75L5.75 7L0.75 13.25" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)"/>
      </svg>
      <svg *ngIf="isAccountRegionShown" class="arrow-down"  width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)" >
        <path d="M13.25 0.75L7 5.75L0.75 0.75" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)" />
      </svg>
    </div>
    <ng-container #profileRegion *ngIf="this.isAccountRegionShown" >
        <div class="profile-section" fxLayout="column" [@slideToggle]="isAccountRegionShown">
          <div class="bottom-part" fxFlex="1 1 100" fxLayout="row" fxLayoutAlign="center center">
            <!-- <div class="section-delete-acc" (click)="deleteAccClick()"><span> Close my account and delete my data</span></div> -->
            <!-- <button class="profile-btn" (click)="deleteAccClick()">
              <span> Close my account and delete my data</span>
            </button> -->
          </div>
          <div class="account-menu-item" (click)="openLegalPage('terms-of-service')">
            <h2 class="region-title">Terms of Services</h2>
          </div>
          <div class="account-menu-item" (click)="openLegalPage('privacy-policy')">
            <h2 class="region-title">Privacy Policy</h2>
          </div>
          <div class="account-menu-item" (click)="signOut()">
            <h2 class="region-title">Sign Out</h2>
            <span class="user-email" *ngIf="firebaseAuth.currentUser?.email">{{firebaseAuth.currentUser?.email}}</span>
          </div>
        </div>
    </ng-container>
  </div>
</div>

<!-- Feedback area -->
<div class="feedback-container">
  <div class="feedback-input-wrapper">
    <textarea
      class="feedback-input"
      placeholder="Type your idea or bug report..."
      [(ngModel)]="feedbackService.feedbackText"
      [disabled]="feedbackService.isSubmitting">
    </textarea>
  </div>
</div>



